import { FC, Fragment } from 'react';
import { Jane, RequestTeamMemberForOrderQuery } from 'types/graphql';
import { InfiniteScrollLoading } from 'components/InfiniteScrollLoading';

import { useTranslation } from 'hooks/useTranslation';
import {
  InfiniteScrollWrapper,
  NoResultsWrapper,
} from 'components/RequestTeamMemberForOrder/RequestTeamMemberForOrder.styled';
import { TeamMemberOption } from 'components/RequestTeamMemberForOrder/src/TeamMemberOption';
interface ITeamMembersListProps {
  data: RequestTeamMemberForOrderQuery;
  value: string;
  name: string;
  onSelect: (e: unknown) => void;
  onLoadMore: () => void;
  isRelayId?: boolean;
}

export const TeamMembersList: FC<ITeamMembersListProps> = ({
  data,
  value,
  name,
  onSelect,
  onLoadMore,
}) => {
  const { t } = useTranslation();
  if (!data || (data?.requestJanes?.edges && data?.requestJanes?.edges.length === 0))
    return <NoResultsWrapper>{t('common:NO_RESULTS')}</NoResultsWrapper>;
  return (
    <Fragment>
      {data?.requestJanes?.edges.map(({ node }) => {
        if (!node) return <Fragment />;
        return (
          <TeamMemberOption
            key={node.id}
            node={node as Jane}
            value={value}
            name={name}
            onSelect={onSelect}
          />
        );
      })}
      {!!data?.requestJanes?.pageInfo.hasNextPage ? (
        <InfiniteScrollWrapper>
          <InfiniteScrollLoading onViewportEnter={onLoadMore} />
        </InfiniteScrollWrapper>
      ) : null}
    </Fragment>
  );
};
